/**
 * This file is auto-generated from FileUploader.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */
export const fileTooLarge = lang => {
    switch (lang) {
        case 'en':
            return 'File is too large';
        case 'pl':
            return 'Plik jest za duży';
    }
};
export const invalidFileType = lang => {
    switch (lang) {
        case 'en':
            return 'Invalid file type';
        case 'pl':
            return 'Nieprawidłowy typ pliku';
    }
};
export const uploadFailed = lang => {
    switch (lang) {
        case 'en':
            return 'Upload failed';
        case 'pl':
            return 'Przesyłanie nie powiodło się';
    }
};
//# sourceMappingURL=FileUploader.loc.js.map